import { ILopActions } from "../../action-types/category/ILopActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILopReducer } from "../../reducer-model/category/ILopReducer";

const iniState: ILopReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lops: []
};

export const lopReducer = (state: ILopReducer = iniState, action: ILopActions): ILopReducer => {
    switch (action.type) {
        case "LOP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "LOP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lops: action.payload
            };
        case "LOP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "LOP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                lopEditing: action.payload
            };
        case "LOP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "LOP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "LOP_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            };
        case "LOP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "LOP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "LOP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "LOP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};
